"use client"

import { ReactNode } from "react"
import { unauthenticatedTRPC } from "domains/trpc/trpc"

interface Props {
    children: ReactNode
}

function Layout({ children }: Props) {
    return <>{children}</>
}

export default unauthenticatedTRPC.withTRPC(Layout)
